<template>
<div class="home" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -11px;">
 <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      
      
      background="#ababab"
      img-width="1024"
      img-height="180"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
    <!-- controls -->
      <!-- Text slides with image -->
      <!-- <b-carousel-slide  img-src="https://p.w3layouts.com/demos/june-2016/01-06-2016/big_store/web/images/co2.jpg">
      
      </b-carousel-slide>
      <b-carousel-slide  img-src="https://p.w3layouts.com/demos/june-2016/01-06-2016/big_store/web/images/co3.jpg" >
     
      </b-carousel-slide> -->


      <!-- Slide with blank fluid image to maintain slide aspect ratio -->
      
    </b-carousel>
    <!-- <div class="buy">
    <v-label class="buy">Buy Now</v-label>
    </div> -->
    
    <!-- <counter/> -->
    
    <offerzone></offerzone>
</div>
  
</template>
<script>
import offerzone from '@/components/Offerzone'
import Counter from '@/components/Counter.vue'
import axios from 'axios';
  export default {
      components: {      
        // offr,
        offerzone,
   
        // Counter,
        
       },
    data() {
        
      return {
        slide: 0,
        sliding: null,
      
      name: 'Offer Zone',
        products : []
      }
    },
     mounted() {
           this.getItems();
            this.$parent.$children[0].$parent.ttlval = this.name

            console.log(this.$el.textContent) 

       },
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      },
      getItems: function () {
      // this.loading = true;
      axios.get(this.$bURL+"item/GetItemDetailsList?Category=Bottles&SubCategory=All")
      .then((response)  =>  {
        // this.loading = false;
        // console.log(response)
        // this.products = response.data;
      }, (error)  =>  {
          console.log(error)
      })
    }
    }
  }
</script>
<style >
.img-fluid {
    max-width: 100%;
    height: 200px !important;
}
.carousel-caption {
    
    z-index: 2 !important;
}
.buy .v-label{
  color: #F06292;
  padding-top: 12px;
  padding-bottom: -10px;
  font-size: 23px;
}

</style>